import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Spinner,
  Modal,
} from "react-bootstrap";
import noImg from "../../../Assets/noimage.png";
import { getImageUrl } from "../../../MIS/Global";
import { colorOptions } from "../../../MIS/Globdata";
import { FaTrash } from "react-icons/fa";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useModal } from "../../ConfirmationModal/ModalContext";
import useToast from "../../../API/GlobalHooks/useToast";
import {
  tbkProduct_deleteItem,
  tbkProduct_updateItem,
} from "../../../API/Service/tbkProductService";
import ButtonEL from "../../GlobalComponent/Elements/ButtonEL";
import EditablePriceTable from "./EditablePriceTable";
import { handleSubmit_sizes } from "./editablePriceTableModel";

const TbkProductListOne = ({ data }) => {
  // const colorOptions = ['Red', 'Blue', 'Green', 'Yellow', 'Black', 'White'];

  const queryClient = useQueryClient();
  const { showModal } = useModal();
  const showToast = useToast();
  const [productNames, setProductNames] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [tempProduct, setTempProduct] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [sizeData, setSizeData] = useState([]);

  const deleteMutation = useMutation({
    mutationFn: tbkProduct_deleteItem,
    onSuccess: () => {
      queryClient.invalidateQueries(["tbkProducts"]); // Refetch sizes after deletion
      showToast("Product deleted successfully", "success");
    },
    onError: (error) => {
      showToast("Failed to delete product; please try again.", "danger");
    },
  });

  const handleDeleteImage = (id) => {
    showModal({
      title: "Delete Confirmation",
      message: "Are you sure you want to delete this product?",
      onConfirm: () => {
        deleteMutation.mutate({ id: id });
      },
      confirmText: "Yes",
      cancelText: "No",
    });
  };

  const saveMutation = useMutation({
    mutationFn: tbkProduct_updateItem,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: (resData) => {},
    onError: (error) => {},
    onSettled: () => {
      setIsLoading(false);
    },
  });

  const handleUpdateProduct = () => {
    let data = {
      id: tempProduct[selectedProduct?.id]?.id,
      productname: tempProduct[selectedProduct?.id]?.productname,
      productcode: tempProduct[selectedProduct?.id]?.productcode,
      productcolor: tempProduct[selectedProduct?.id]?.productcolor,
      productprice: tempProduct[selectedProduct?.id]?.productprice,
    };
    saveMutation.mutate(data, {
      onSuccess: () => {
        // setSelectedProduct(null);
      },
    });
  };

  useEffect(() => {
    if (data?.tbkProducts) {
      setProductNames(
        data.tbkProducts.map((element) => element?.productname || "")
      );
    }
  }, [data]);

  const handleImageClick = (product) => {
    // setSelectedProduct({ ...product });
    setSelectedProduct(product);

    setTempProduct((prevTemp) => ({
      ...prevTemp,
      [product.id]: prevTemp?.[product.id] || { ...product }, // Ensure previous edits persist
    }));
  };

  const handleChangeUpdate = (field, value) => {
    setTempProduct((prev) => ({
      ...prev,
      [selectedProduct.id]: {
        ...prev[selectedProduct.id], // Keep previous modifications of the current product
        [field]: value, // Update the specific field
      },
    }));
  };
  return (
    <>
      <Container
        fluid
        style={{ overflow: "hidden", overflowY: "auto", height: "100vh" }}
      >
        <Row>
          {data?.isLoadingTbkProducts && (
            <Col md={12}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "250px" }}
              >
                <Spinner animation="border" />
              </div>
            </Col>
          )}
          {data?.tbkProducts?.map((element, index) => (
            <>
              <Col
                key={index}
                xs={6}
                md={4}
                className="d-flex align-items-center p-1 gx-1"
              >
                <div
                  className="image-container-list"
                  onClick={() => handleImageClick(element)}
                >
                  <Image
                    src={getImageUrl(element?.imgpath) || noImg}
                    alt={element?.productname}
                    className="img-fluid rounded"
                    style={{
                      width: "100%", // Makes image responsive to column
                      height: "auto", // Keeps aspect ratio
                      aspectRatio: "1/1",
                      objectFit: "contain", // Ensures full fit inside the column
                    }}
                  />
                  <Button
                    className="delete-button-list"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteImage(element?.id);
                    }}
                  >
                    <FaTrash />
                    {/* {index} */}
                  </Button>
                </div>
              </Col>
            </>
          ))}
        </Row>
      </Container>

      <Modal
        show={!!selectedProduct}
        onHide={() => setSelectedProduct(null)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <Row className="align-items-stretch">
              <Col md={5} className="d-flex flex-column gap-3">
                <Col md={5}>
                  <Image
                    src={getImageUrl(selectedProduct?.imgpath) || noImg}
                    className="w-100"
                    style={{ aspectRatio: "1/1", objectFit: "contain" }}
                  />
                </Col>
                <div className="d-flex flex-column gap-3 h-100">
                  <div>
                    <Form.Group className="mb-2">
                      <Form.Label>Product Name</Form.Label>
                      <Form.Control
                        className="py-1"
                        size="sm"
                        type="text"
                        value={tempProduct[selectedProduct?.id]?.productname}
                        onChange={(e) =>
                          handleChangeUpdate("productname", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label>Product Code</Form.Label>
                      <Form.Control
                        className="py-1"
                        type="text"
                        value={
                          tempProduct[selectedProduct?.id]?.productcode || ""
                        }
                        onChange={(e) =>
                          handleChangeUpdate("productcode", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label>Color</Form.Label>
                      <Form.Control
                        className="py-1"
                        type="text"
                        value={
                          tempProduct[selectedProduct?.id]?.productcolor || ""
                        }
                        onChange={(e) =>
                          handleChangeUpdate("productcolor", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Form.Group className="mb-2 d-none">
                      <Form.Label>Price</Form.Label>
                      <Form.Control
                        className="py-1"
                        type="number"
                        value={
                          tempProduct[selectedProduct?.id]?.productprice || ""
                        }
                        onChange={(e) =>
                          handleChangeUpdate("productprice", e.target.value)
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
              </Col>

              <Col md={7} className="h-100">
                <EditablePriceTable
                  data={selectedProduct}
                  sizeData={sizeData}
                  setSizeData={setSizeData}
                />
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={() => setSelectedProduct(null)}
          >
            Cancel
          </Button>
          <ButtonEL
            type="button"
            variant="primary"
            onClick={(e) => {
              handleSubmit_sizes({ sizeData, setIsLoading,pid:selectedProduct?.id});
              handleUpdateProduct();
            }}
            isLoading={isLoading}
            loadingText="Updating..."
          >
            Update
          </ButtonEL>
        </Modal.Footer>
      </Modal>

      <style>{`
      .image-container-list {
      position: relative;
      width: 100%;
      cursor: pointer;
      }

      .delete-button-list {
      position: absolute;
      top: 5px;
      right: 5px;
      display: none;
      z-index: 10;
      background: rgba(255, 0, 0, 0.8);
      border: none;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      cursor: pointer;
      }

      .image-container-list:hover .delete-button-list {
      display: block;
      }

      @media (min-width: 768px) {
      .modal-body {
      display: flex;
      gap: 1rem;
      }
      .w-md-50 {
      width: 50%;
      }
      }
    `}</style>
    </>
  );
};

export default TbkProductListOne;
